<h2 mat-dialog-title>Create New User</h2>
<mat-dialog-content>
  <form [formGroup]="newUserForm">
    <mat-form-field style="width:100%">
      <mat-label>User Email</mat-label>
      <input matInput placeholder="Enter the email address of new user" formControlName="userEmail" />
      <mat-error *ngIf="newUserForm.controls['userEmail'].invalid && (newUserForm.controls['userEmail'].touched || newUserForm.controls['userEmail'].dirty)">
        <p *ngIf="newUserForm.controls['userEmail'].errors.required">User Email is <strong>required</strong></p>
        <p *ngIf="newUserForm.controls['userEmail'].errors.email">Email must be a valid email.</p>
        <p *ngIf="newUserForm.controls['userEmail'].errors.maxlength">Email can not exceed <strong>50</strong> characters.</p>
      </mat-error>
    </mat-form-field>
    <mat-checkbox matInput style="padding-top: 15px; width: 100%" formControlName="twoFactorEnabled">Enable two factor authentication</mat-checkbox>
    <mat-form-field style="padding-top: 15px; width: 100%">
      <mat-label>Message</mat-label>
      <textarea matInput rows="4" placeholder="Optional welcome message to new user" formControlName="message"></textarea>
      <mat-error *ngIf="newUserForm.controls['message'].errors && (newUserForm.controls['message'].touched || newUserForm.controls['message'].dirty)">
        <p *ngIf="newUserForm.controls['message'].errors.maxlength">Message can not exceed <strong>1024</strong> characters.</p>
      </mat-error>
    </mat-form-field>
  </form>
  <div><span style="font-size: small; width: fit-content;">Note: You must add at least one case to the new user before they can log in.</span></div>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" [disabled]="!newUserForm.valid" (click)="addNewUser()">Add User</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
